import { useSpecialFunctions } from "../../functions";
const LastChangesTable = ({
  lastChangesInfo,
  setFieldNameSelected,
  lastChangesRowSelected,
  setLastChangesRowSelected,
  handleRowClick,
}) => {
  const { getTimeInfo } = useSpecialFunctions();
  const onRowClick = (index, fieldName) => {
    setLastChangesRowSelected(index);
    setFieldNameSelected(fieldName);
    if (handleRowClick) handleRowClick(fieldName);
  };

  const renderRows = () => {
    if (!lastChangesInfo.length) {
      return (
        <tr>
          <td
            colSpan={8}
            className="text-center text-muted"
            style={{ verticalAlign: "middle" }}
          >
            No Last Changes to display
          </td>
        </tr>
      );
    }

    return lastChangesInfo.map((item, index) => {
      const placedDate = new Date(item.placeddate);
      const formattedDate = placedDate.toLocaleDateString("en-GB");
      const formattedTime = getTimeInfo(item.placeddate);

      const isSelected = lastChangesRowSelected === index;

      return (
        <tr
          key={`${item.idtracklog || "row"}-${index}`}
          onClick={() => onRowClick(index, item.fieldname)}
          className={isSelected ? "classActiveMultiselect" : ""}
        >
          <td className="text-left align-middle">{item.fieldname}</td>
          <td className="text-center align-middle">{item.oldvalue}</td>
          <td className="text-center align-middle">{item.newvalue}</td>
          <td className="text-center align-middle">{item.loginname}</td>
          <td className="text-center align-middle">
            {formattedDate} {formattedTime}
          </td>
          <td className="text-center align-middle">{item.phoneline}</td>
          <td className="text-center align-middle">{item.ip}</td>
        </tr>
      );
    });
  };

  return (
    <div style={{ maxHeight: "500px", overflow: "auto" }}>
      <table className="table table-hover table-sm mt-2">
        <thead
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "#d9d9d9",
          }}
        >
          <tr className="text-center">
            <th>FieldName</th>
            <th>Old Value</th>
            <th>New Value</th>
            <th>Modified By</th>
            <th>Last Modified</th>
            <th>Phone</th>
            <th>IP</th>
          </tr>
        </thead>
        <tbody className="table-lg">{renderRows()}</tbody>
      </table>
    </div>
  );
};

export default LastChangesTable;
